import { redirectLogin, tryRefreshSessionOrRedirect } from "@/setup/auth-hooks";
import { Code } from "@connectrpc/connect";

import { useServiceFactory } from "@socotec.io/socio-grpc-api";
import { useLanguageStore } from "@/store/language.js";
import { useOidcStore } from "vue3-oidc";
const refreshInterceptor = (next) => async (req) => {
  // case when accessToken still valid in time
  if (useOidcStore().state.value.token) {
    return await next(req);
  }
  console.log("Token expired trying to reconnect...");
  await tryRefreshSessionOrRedirect();
  return await next(req);
};

const errorInterceptor = (next) => async (req) => {
  // case when accessToken still valid in time but session expired
  // and revoked all tokens
  try {
    return await next(req);
  } catch (err) {
    if (err.code === Code.Unauthenticated) {
      await redirectLogin();
    }
    throw err;
  }
};

const initRapsoteUserLanguageInterceptor = (next) => async (req) => {
  const userLanguage = useLanguageStore().lang;
  req.header.set("Accept-Language", userLanguage);
  return await next(req);
};

const interceptors = [
  refreshInterceptor,
  errorInterceptor,
  initRapsoteUserLanguageInterceptor,
];

// __CONNECT_WEB_DEVTOOLS__ is loaded in as a script, so it is not guaranteed to be loaded before your code.
if (window.__CONNECT_WEB_DEVTOOLS__ !== undefined) {
  interceptors.push(window.__CONNECT_WEB_DEVTOOLS__);
}
// To get around the fact that __CONNECT_WEB_DEVTOOLS__ might not be loaded, we can listen for a custom event,
// and then push the interceptor to our array once loaded.
window.addEventListener("connect-web-dev-tools-ready", () => {
  if (typeof window.__CONNECT_WEB_DEVTOOLS__ !== "undefined") {
    interceptors.push(window.__CONNECT_WEB_DEVTOOLS__);
  }
});

const tokenGetter = () => useOidcStore().state.value.token;

export const useService = useServiceFactory(
  tokenGetter,
  import.meta.env.VITE_APP_SOCIO_GRPC_API_ENV,
  import.meta.env.VITE_APP_SERVICE_SLUG,
  interceptors,
);
